import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, combineLatest } from 'rxjs';
import { skip, takeUntil, map } from 'rxjs/operators';
import { CheckListsCommonService } from '../../services/check-lists-common.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-check-lists-page',
  templateUrl: './check-lists-page.component.html',
  styleUrls: ['./check-lists-page.component.scss'],
  standalone: false,
})
export class CheckListsPageComponent implements OnInit, OnDestroy {
  tabActiveManual;

  tabChange$ = new Subject();
  destroyed$ = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private checklistsCommonService: CheckListsCommonService
  ) {}

  get isAdministrator$(): Observable<boolean> {
    return this.checklistsCommonService.isAdministrator();
  }

  get isCurratorOrDispatcher$(): Observable<boolean> {
    return this.checklistsCommonService.isCuratorOrDispatcher();
  }

  get isCurratorOrDispatcherGRRS$(): Observable<boolean> {
    return this.checklistsCommonService.isCuratorOrDispatcherGRRS();
  }

  onTabChange(changedTab): void {
    this.router.navigate([changedTab.id], {
      relativeTo: this.activatedRoute,
    });
  }

  ngOnInit(): void {
    const currentUrl = this.router.url;
    const currentTab = currentUrl.slice(currentUrl.lastIndexOf('/') + 1);

    if (currentTab && currentTab !== 'check-lists') {
      this.tabActiveManual = currentTab;
    } else {
      combineLatest([this.isAdministrator$, this.isCurratorOrDispatcher$, this.isCurratorOrDispatcherGRRS$])
        .pipe(
          map(([isAdmin, isCuratorOrDispatcher, isCuratorOrDispatcherGRRS]) => {
            if (isAdmin) return 'composing';
            if (isCuratorOrDispatcher) return 'reporting';
            if (isCuratorOrDispatcherGRRS) return 'reporting-grrs';
            return 'composing';
          })
        )
        .subscribe((firstAvailableTab) => {
          this.tabActiveManual = firstAvailableTab;
          this.router.navigate([firstAvailableTab], {
            relativeTo: this.activatedRoute,
          });
        });
    }

    this.tabChange$.pipe(skip(1), takeUntil(this.destroyed$)).subscribe(({ currentTab: changeTab }) => this.onTabChange(changeTab));
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
  }
}
